import Vue from 'vue'
import { Mixin } from 'vue-mixin-decorator'
import { getRequest, postRequest, patchRequest } from '@/plugins/api-axios'

@Mixin
export default class NotificationMixin extends Vue {
    url_notification = process.env.VUE_APP_NOTIFICATION_BASE_URL

    get headersmixins() {
        return {
            'Content-Type': 'application/vnd.api+json',
        }
    }

    // NOTIFICATION
    async searchNotifications(params: any) {
        let url = `${this.url_notification}/notifications?include=notificationType,actingUser,resource`
        let res = await getRequest(url, this.headersmixins, params)

        let notifications: any = {}
        let notificationTypes: any = {}
        let notificationResources: any = {}
        let users: any = {}

        res.data.data.map((item: any) => {
            notifications[item.id] = item
        })

        res.data.included.map((item: any) => {
            switch (item.type) {
                case 'notificationType':
                    notificationTypes[item.id] = item
                    break
                case 'notificationResource':
                    notificationResources[item.id] = item
                    break
                case 'user':
                    users[item.id] = item
                    break
            }
        })

        this.$store.commit('notifications', {
            ...this.$store.getters.notifications,
            ...notifications,
        })
        this.$store.commit('notificationTypes', {
            ...this.$store.getters.notificationTypes,
            ...notificationTypes,
        })
        this.$store.commit('notificationResources', {
            ...this.$store.getters.notificationResources,
            ...notificationResources,
        })
        this.$store.commit('notificationUsers', {
            ...this.$store.getters.notificationUsers,
            ...users,
        })

        return res.data.data
    }

    // NOTIFICATION GROUP
    async searchNotificationGroups(params: any) {
        let url = `${this.url_notification}/notificationGroups?include=topNotifications.actingUser,topNotifications.notificationType,resource`
        let res = await getRequest(url, this.headersmixins, params)

        let notificationGroups: any = {}
        let notifications: any = {}
        let notificationResources: any = {}
        let notificationTypes: any = {}
        let users: any = {}

        res.data.data.map((item: any) => {
            notificationGroups[item.id] = item
        })

        res.data.included.map((item: any) => {
            switch (item.type) {
                case 'notification':
                    notifications[item.id] = item
                    break
                case 'notificationResource':
                    notificationResources[item.id] = item
                    break
                case 'notificationType':
                    notificationTypes[item.id] = item
                    break
                case 'user':
                    users[item.id] = item
                    break
            }
        })

        this.$store.commit('notificationGroups', {
            ...this.$store.getters.notificationGroups,
            ...notificationGroups,
        })
        this.$store.commit('notifications', {
            ...this.$store.getters.notifications,
            ...notifications,
        })
        this.$store.commit('notificationResources', {
            ...this.$store.getters.notificationResources,
            ...notificationResources,
        })
        this.$store.commit('notificationTypes', {
            ...this.$store.getters.notificationTypes,
            ...notificationTypes,
        })
        this.$store.commit('notificationUsers', {
            ...this.$store.getters.notificationUsers,
            ...users,
        })

        return res.data.data
    }

    // USER SETTINGS
    async getGeneralNotificationUserSettings(id: string) {
        let url = `${this.url_notification}/userSettings/${id}`
        let res = await getRequest(url, this.headersmixins)
        this.$store.commit('generalNotificationUserSettings', res.data.data)
        return res.data.data
    }

    async patchGeneralNotificationUserSettings(params: any) {
        let url = `${this.url_notification}/userSettings/${params.id}`
        let res = await patchRequest(url, this.headersmixins, params)
        this.$store.commit('generalNotificationUserSettings', res.data.data)
        return res.data.data
    }

    // NOTIFICATION USER SETTINGS
    async searchNotificationUserSettings(params) {
        let url = `${this.url_notification}/notificationUserSettings?include=project`
        let res = await getRequest(url, this.headersmixins, params)
        return res.data.data
    }

    async patchNotificationUserSettings(params: any) {
        let url = `${this.url_notification}/notificationUserSettings/${params.id}?include=project`
        let res = await patchRequest(url, this.headersmixins, params)
        return res.data.data
    }

    // NOTIFICATION TYPES
    async getNotificationTypes(params?: any) {
        let url = `${this.url_notification}/notificationTypes?include=userOverrides.project`
        let res = await getRequest(url, this.headersmixins, params)

        let notificationTypes: any = {}
        let notificationUserSettings: any = {}

        res.data.data.map((item: any) => {
            notificationTypes[item.id] = item
        })

        res.data.included.map((item: any) => {
            switch (item.type) {
                case 'notificationUserSettings':
                    notificationUserSettings[item.id] = item
                    break
            }
        })

        this.$store.commit('notificationTypes', {
            ...this.$store.getters.notificationTypes,
            ...notificationTypes,
        })
        this.$store.commit('notificationUsersSettings', {
            ...this.$store.getters.notificationUsersSettings,
            ...notificationUserSettings,
        })

        return res.data.data
    }
}
